import { ReactComponent as Docs } from "src/assets/svg/document-management.svg";
import { JobInterview } from "src/types";
import Tag from "../components/Tag";
import { dateFormat1 } from "src/utils/dates/formats";
import FeedbackCard from "../components/FeedbackCard";
import SkillsFeedback from "../components/SkillsFeedback";
import Button from "../../../../../components/Button";
import { isProduction } from "../../../../../config/env";
import { generateFeedback } from "../../../../../network/interview";
import useLoader from "../../../../../hooks/useLoader";
import CompleteButtons from "../components/CompleteButtons";
import { Feedback } from "src/classes/models/interview";
import { JobInterviewClass } from "src/classes/models/job_interview";

interface IReport {
  interview: JobInterview;
  feedback?: Feedback;
  setInterview: (i: JobInterview | undefined) => void;
}

const Report = ({ interview, feedback, setInterview }: IReport) => {
  const { loading, ldng } = useLoader(generateFeedback, {
    successMsg: "Feedback queued for generation",
    errorMsg: "Error generating feedback"
  });
  if (!feedback) return <Pending />;
  const { overall, work_experience, communication, skills } = feedback;
  const { email, Job, Interview } = interview;
  const { date_completed } = Interview;
  const _Interview = new JobInterviewClass(interview);

  return (
    <div className="max-w-[1110px] mx-auto mt-10">
      <div className="bg-white rounded-xl  border-[0.1px] border-odf-light p-9 mb-6">
        <div className="flex ">
          {/* Tags */}
          <div className="flex flex-wrap gap-y-9 gap-x-[44px] w-[624px] h-fit">
            <Tag title="Email Address" text={email} />
            <Tag title="Job Role" text={Job.job_title} />
            {date_completed && <Tag title="Date of interview" text={dateFormat1(date_completed)} />}
            <Tag title="Interview Duration" text={_Interview.interviewDurationText()} />
          </div>
          {/* Overview */}
          <div className="bg-white rounded-3xl border-[1px] border-odfblue border-opacity-65 w-[180px] p-4  ml-auto relative">
            <p
              className={`text-[60px] font-poppins font-semibold text-center`}
              style={overall._score.style}
            >
              {overall.score === "Incomplete" ? "N/A" : overall.score}
            </p>
            <p className="font-poppins text-2xl font-semibold text-center  mt-2">
              Overall Hire Score
            </p>
            {!isProduction && (
              <Button
                loading={loading}
                onClick={() => ldng({ id: interview.id })}
                className="absolute !w-fit -top-4 -right-10 px-2"
              >
                Rgn
              </Button>
            )}
          </div>
        </div>
        <CompleteButtons interview={interview} onUpdate={setInterview} />
      </div>
      {/* Overall */}
      <FeedbackCard feedback={overall} />
      {/* Grid */}
      <div className="grid grid-cols-2 gap-10 my-9">
        <FeedbackCard feedback={work_experience} />
        <FeedbackCard feedback={communication} />
        {skills && <FeedbackCard feedback={skills.technical} />}
        {skills && <FeedbackCard feedback={skills.intercultural} />}
      </div>

      {/* Skills feedback */}
      <SkillsFeedback feedback={skills} />
    </div>
  );
};

const Pending = () => (
  <div className="max-w-[400px] mx-auto mt-20 flex flex-col items-center text-center">
    <Docs />
    <p className="font-semibold font-poppins text-xl mt-[50px]">Feedback is being generated</p>
    <p className="font-poppins text-base font-[500] text-[#8A8A8A] mt-[10px] ">
      We are currently processing feedback for this candidate. Please try again in a little while.
    </p>
  </div>
);

export default Report;
